module.exports = __webpack_public_path__ + "frontend-assets/img/info-star.735154ca.png";